//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    ad: {
      type: Object || null,
      default: () => {
        return {
          isAd: true,
          id: '',
          img: '',
          link: '',
          title: '',
        };
      },
    },
  },
};
